import script from "./VideoRedirector.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoRedirector.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__